import type { ViewportRaw } from "..";
import type { NexusHandler } from "../../nexus/function/function.types";

const DIV = "div";

/**
 *
 */
export const getScrollbarWidth: NexusHandler<ViewportRaw["getScrollbarWidth"]> = () => {
  /*                           */
  const outer = document.body.appendChild(document.createElement(DIV));
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll"; /*                          */

  /*                                                     */
  const inner = outer.appendChild(document.createElement(DIV));

  /*                                                                        */
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  /*                                       */
  outer.parentNode!.removeChild(outer);

  return scrollbarWidth;
};
